/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "Gvvo6vUpJRc",
    alt: "review-video",
    views: "7.2M",
    duration: "15:24",
    title: "AirPods Max Review: Luxury Listening!",
    thumbnail: "https://i.ytimg.com/vi/Gvvo6vUpJRc/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "Unboxing",
    description:
      "Apple made some pretty great headphones with a pretty dumb case.While the Apple AirPod Max is a great pair of headphones with best-in-class active noise cancelling (ANC) and a good sound signature, it also has a few annoying quirks that make it very obviously an Apple product. If you live in the Apple ecosystem and already love your AirPods Pro, then the AirPods Max is more of the same just in a pair of over-ears.",
  },
  {
    _id: "oOaQVvNK4EU",
    alt: "review-video",
    views: "57k",
    duration: "10:54",
    title: "Prime Picks! - The #1 Headphones on Amazon!",
    thumbnail: "https://i.ytimg.com/vi/oOaQVvNK4EU/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "Comparison",
    description:
      "The absolute best selling audio products on Amazon - are they any good? Digital noise cancelling: Industry leading Active Noise Cancellation (ANC) lends a personalized, virtually soundproof experience at any situation Voice assistant: Alexa, Google Assistant & Siri enabled (In-built) for voice access to music, information and more. Activate with a simple touch. Speak-to-chat: Headphones use an array of smart technologies to create a seamless, hands-free listening experience. For eg, simply start speaking to automatically pause your music in Speak-to-Chat. Wearing Detection: Proximity sensor and two acceleration sensors in your headphones can detect whether you are wearing them or not. then adapt playback accordingly to help save battery power",
  },
  {
    _id: "YPln3JP_gKs",
    alt: "review-video",
    views: "3.2M",
    duration: "6:49",
    title: "Bose Headphones 700: The King is Back!",
    thumbnail: "https://i.ytimg.com/vi/YPln3JP_gKs/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "New",
    description:
      "Terrible name. Excellent headphones. Companies compete; we win!. Critically acclaimed for their powerful noise cancelling, astonishing sound and unrivalled voice pickup, Bose Noise Cancelling Headphones 700 help turn any space into the perfect place to listen to music, get work done or just shut out the world for a few moments and relax. So if you’re looking for the best wireless Bluetooth® headphones for music and calls, you’ve found them.",
  },

  {
    _id: "nuNYtj8keaE",
    alt: "review-video",
    views: "3.8M",
    duration: "8:04",
    title: "My Favorite Wireless Headphones | 2018!",
    thumbnail: "https://i.ytimg.com/vi/nuNYtj8keaE/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "Unboxing",
    description:
      "Better hop on this wireless train before it leaves the station...",
  },

  {
    _id: "cG8PXdTlDag",
    alt: "review-video",
    views: "196K",
    duration: "9:36",
    title: "AirPods Pro Review: Imperfectly Perfect!",
    thumbnail: "https://i.ytimg.com/vi/cG8PXdTlDag/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "New",
    description: "AirPods Pro are the best non-best headphones you can buy.",
  },

  {
    _id: "XDBbzjUbGPU",
    category: "Noise Cancelling",
    alt: "I Never Thought They Could Be This Good...",
    views: "2.7M",
    duration: "16:14",
    title: "I Never Thought They Could Be This Good...",
    thumbnail:
      "https://i.ytimg.com/vi/XDBbzjUbGPU/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBsvLNXDPAq5aS6HJDqvA6fu8117A",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "One thing I like that a lot of review gloss over is PC functionality with these headphones. I have had all sorts of problems with both Bose and Sony headphone PC Bluetooth because they seem to be built around an app ecosystem.",
  },

  {
    _id: "zFy2TwKKw6Y",
    category: "Comparison",
    alt: "Airpods Comparison",
    views: "100K",
    duration: "8:38",
    title: "Airpods Comparison: Which One Is Right For YOU?",
    thumbnail:
      "https://i.ytimg.com/vi/zFy2TwKKw6Y/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLC9vA7MDbOoim7spkkIP43JMzl4tA",
    creatorName: "Joshua Chang",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLRxHZgGHo_Ddm_raaAALu6Fb9wqMSaD2bs5Ke7rrA=s68-c-k-c0x00ffffff-no-rj",
    description:
      "There are now three Airpods to choose from (excluding the Max), and it can be a little confusing to figure out what's right for you. In this video, I try to break down the most important differences between the Airpods 2 (2nd Generation), Airpods 3 (3rd Generation), and Airpods Pros. Thanks for watching!",
  },

  {
    _id: "ByayqNQU2fA",
    alt: "review-video",
    views: "1.9M",
    duration: "9:02",
    title: "Surface Headphones 2: Matte Black Everything!",
    thumbnail: "https://i.ytimg.com/vi/ByayqNQU2fA/hq720.jpg",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",
    category: "Noise Cancelling",
    description:
      "Microsoft. Do you think you can get me to like your headphones just for a new color? Surround yourself with spectacular Omnisonic sound for music, shows, and calls. Stay focused with adjustable noise cancellation. And, listen in comfort with up to 18.5 hours of music listening time.",
  },

  {
    _id: "ueY_SSItHwY",
    category: "Comparison",
    alt: "AirPods Max vs Sony XM4",
    views: "483K",
    duration: "10:58",
    title: "AirPods Max vs Sony XM4 Headphones",
    thumbnail:
      "https://i.ytimg.com/vi/ueY_SSItHwY/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCQ545fdQTcMkrIQTPKtnIVdkh0JQ",
    creatorName: "LaterClips",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQ2KzKGZzUIE-JARbTtsPnd7_mareCoIvIVH495=s48-c-k-c0x00ffffff-no-rj",
    description:
      "Apple release of these airpods max is actually great publicity for sony. Didnt know of the XM4s before now.",
  },

  {
    _id: "Fl4Djf5Vr0I",
    category: "Unboxing",
    alt: "AirPods Max Unboxing Every Color",
    views: "1.5M",
    duration: "20:00",
    title: "AirPods Max Unboxing Every Color",
    thumbnail:
      "https://i.ytimg.com/vi/Fl4Djf5Vr0I/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDogIsWt3sz7ZnIPGyZ7dCD6px-wg",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",
    description:
      "AirPods Max unboxing featuring the AirPods Max in Silver, Space Gray, Sky Blue, Green, and Pink. In this video I also give Apple's AirPods Max a test for movies and music. AirPods Max feature Apple's spatial audio, noise cancelling and a transparency mode.",
  },

  {
    _id: "cRNqVGfy2O4",
    category: "Noise Cancelling",
    alt: "The Best Noise Cancelling Headphones",
    views: "5.2M",
    duration: "9:18",
    title: "The Best Noise Cancelling Headphones... Bose or Sony?",
    thumbnail:
      "https://i.ytimg.com/vi/cRNqVGfy2O4/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAmG5D7m5gu4U18qHV896l6BDlIvQ",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "The Bose QC35 and now QC35 II are widely regarded as the benchmark for wireless noise cancelling headphones. The new Sony WH1000XM3 headphones are looking to change that. So the question is... Has Sony done enough to dethrone Bose? Which is the best pair of wireless noise cancelling headphones for 2018, 2019 and beyond?",
  },

  {
    _id: "GlwYr5m-Ifo",
    category: "Noise Cancelling",
    alt: "Libratone Air+ 2 Noise Cancelling Earbuds Unboxing",
    views: "1.2M",
    duration: "8:08",
    title: "Libratone Air+ 2 Noise Cancelling Earbuds Unboxing",
    thumbnail:
      "https://i.ytimg.com/vi/GlwYr5m-Ifo/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBpp_J53Zrf0bYeh3auuUEldr8FLw",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "Libratone AIR+ second edition are fully wireless earbuds featuring noise cancelling and transparency. Sponsored by Libratone. Libratone AIR+ (2nd Gen) earbuds.",
  },

  {
    _id: "DAxj9CjczXw",
    category: "Noise Cancelling",
    alt: "Bose QC35",
    views: "3.1M",
    duration: "5:34",
    title: "Bose QC35: Best Noise Cancelling Headphones?",
    thumbnail:
      "https://i.ytimg.com/vi/DAxj9CjczXw/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDjd8bJlQxYqIEiNVITjG_vPrHeVQ",
    creatorName: "Marques Brownlee",
    avatar:
      "https://yt3.ggpht.com/lkH37D712tiyphnu0Id0D5MwwQ7IRuwgQLVD05iMXlDWO-kDHut3uI4MgIEAQ9StK0qOST7fiA=s48-c-k-c0x00ffffff-no-rj",

    description:
      "Bose QuietComfort 35: Premium noise cancelling headphones get a successor.",
  },

  {
    _id: "3CsrkrFzfUk",
    category: "New",
    alt: "Top 5 BEST Headphones of [2022]",
    views: "29k",
    duration: "10:12",
    title: "Top 5 BEST Headphones of [2022]",
    thumbnail:
      "https://i.ytimg.com/vi/3CsrkrFzfUk/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBZmy8pr8Eic8qWq1YAAKmTzki8eA",
    creatorName: "Top 5 picks",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLRxHZgGHo_Ddm_raaAALu6Fb9wqMSaD2bs5Ke7rrA=s68-c-k-c0x00ffffff-no-rj",

    description:
      "We have just laid out the top 5 best headphones 2022. In 5th place is the Jabra Elite 45, our pick for the best budget headphones. In 4th place is the Sennheiser HD 450BT, our pick for the best value headphones. In 3rd place is the Beyerdynamic DT 700 Pro X, our pick for the best wired headphones. In 2nd place is the Bose QuietComfort 45, our pick for the best runner-up headphones. In 1st place is the Sony WH-1000XM4, our pick for the best overall headphones.",
  },

  {
    _id: "rr5pdj1fYY0",
    category: "New",
    alt: "BEST Wireless Earbuds of 2022!",
    views: "3.6k",
    duration: "11:00",
    title: "BEST Wireless Earbuds of 2022!",
    thumbnail:
      "https://i.ytimg.com/vi/rr5pdj1fYY0/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAogvuRsI2rRvl63zpzQfKJkh5ecg",
    creatorName: "Karl Conrad",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLRxHZgGHo_Ddm_raaAALu6Fb9wqMSaD2bs5Ke7rrA=s68-c-k-c0x00ffffff-no-rj",

    description:
      "Here are my top picks for the best wireless earbuds of 2021 and into early 2022!",
  },

  {
    _id: "iMKvEMBADIo",
    category: "Noise Cancelling",
    alt: "Sony WF-1000XM4",
    views: "183k",
    duration: "8:00",
    title: "Sony WF-1000XM4 - The Ultimate Earphones With Noise Cancellation",
    thumbnail:
      "https://i.ytimg.com/vi/iMKvEMBADIo/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD4Hr_rnwvkRZNXlC5jog-jziK-TQ",
    creatorName: "Technical Guruji",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQ8PSwMRTU8HG_vDunTQ7eYgSqx9ju7vjDNe8dpXm8=s48-c-k-c0x00ffffff-no-rj",

    description:
      "Namaskaar Dosto, is video mein maine aapse baat ki hai Sony WF-1000XM4 Earphones ke baare mein aur share ki hai inhi Sony WF-1000XM4 Earphones ki Unboxing aur ek first look video.",
  },

  {
    _id: "Uaf5Uzh3PeE",
    category: "New",
    alt: "5 Best awesome Headphones 2022",
    views: "4.8k",
    duration: "6:33",
    title: "5 Best awesome Headphones 2022",
    thumbnail:
      "https://i.ytimg.com/vi/Uaf5Uzh3PeE/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA-2iglq4KLtrB1VR-kxDGL8GD96Q",
    creatorName: "HowMuchTech",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLR6ei2b_LP8uyoNI4szk38_klY0XDyCcJBeL4c_=s48-c-k-c0x00ffffff-no-rj",

    description:
      "In this video I listed Best awesome Headphones of 2022 which you can buy.",
  },
  {
    _id: "mUNvvXvcQTs",
    category: "Unboxing",
    alt: "AirPods Max equals Pure Apple Luxury",
    views: "3M",
    duration: "10:30",
    title: "AirPods Max equals Pure Apple Luxury",
    thumbnail:
      "https://i.ytimg.com/vi/mUNvvXvcQTs/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAwJsSn6SQqcb0Kt8VSRGh9JznZGA",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "Apple just launched its most expensive set of headphones the new AirPods Max.",
  },

  {
    _id: "ca1XkpVe-7A",
    category: "Unboxing",
    views: "1.6M",
    duration: "13:02",
    alt: "Unboxing Pure Technological Luxury",
    title: "Unboxing Pure Technological Luxury",
    thumbnail:
      "https://i.ytimg.com/vi/ca1XkpVe-7A/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAomuz-gRJIeE3L1D1R1mEApgJS6g",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "This video features the Ultrasone Edition 15 premium headphones.",
  },

  {
    _id: "X7FLCHVXpsA",
    category: "Unboxing",
    views: "1M",
    duration: "6:05",
    alt: "What Makes These Headphones So Expensive?",
    title: "What Makes These Headphones So Expensive?",
    thumbnail:
      "https://i.ytimg.com/vi/nynvu5VFr8I/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDg-jPYooJ3NM6N3eRnkQ19ol03lw",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description: "Kevin Durant + Master & Dynamic MW65 Headphones.",
  },

  {
    _id: "yhavtVpEW2E",
    category: "Comparison",
    views: "1.6M",
    duration: "4:05",
    alt: "Earphones Comparison",
    title: "5 Reasons Earphones Are Better Than Headphones",
    thumbnail:
      "https://i.ytimg.com/vi/yhavtVpEW2E/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAaC9_RUziFvgtTxEYvUPKsjv4siQ",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "In this video let's see reasons for which earphones are better than headphones",
  },

  {
    _id: "sRVRN2DlDp4",
    category: "Unboxing",
    views: "1.7M",
    duration: "5:12",
    alt: "The Best Headphones That Money Can Buy",
    title: "The Best Headphones That Money Can Buy",
    thumbnail:
      "https://i.ytimg.com/vi/sRVRN2DlDp4/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDuSlaWL7UM151iq1lcdxbNAjso7Q",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "The Sennheiser HD 820 is probably the coolest set of headphones I've ever seen. They are a sealed (and slightly modified) version of the famous HD 800. The HD 820 captured lots of attention at CES 2018 and I'm glad I had the chance to be one of the first to listen to them. Hopefully I'll be able to unbox some HD 820s sometime soon.",
  },

  {
    _id: "8khvLYW_fnM",
    category: "Unboxing",
    views: "9.8M",
    duration: "10:08",
    alt: "Earphones! (Shure SE846 Unboxing & Test)",
    title: "Earphones! (Shure SE846 Unboxing & Test)",
    thumbnail:
      "https://i.ytimg.com/vi/8khvLYW_fnM/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDplpV2Ef5mNPMbfzWc8XcOMVeTIw",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "Welcome to my Shure SE846 unboxing. Here are some detailed specs from the manufacturer. Key Features: Quad Hi-Definition MicroDrivers for extended high-end clarity.",
  },

  {
    _id: "qQOqk2zUttI",
    category: "New",
    views: "1.3M",
    duration: "9:30",
    alt: "These New Earbuds Can Clean Themselves...",
    title: "These New Earbuds Can Clean Themselves...",
    thumbnail:
      "https://i.ytimg.com/vi/qQOqk2zUttI/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAMq2MRoS6WDZ3LUjtpl9tYIWo1uA",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description: "LG's new self-cleaning Tone Free earbuds.",
  },

  {
    _id: "49TU6rdYZ0s",
    category: "Comparison",
    views: "4.7M",
    duration: "6:31",
    alt: "$8 Headphones Vs. $80 Beats Headphones",
    title: "$8 Headphones Vs. $80 Beats Headphones",
    thumbnail:
      "https://i.ytimg.com/vi/49TU6rdYZ0s/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAj5GcmOMpPdGFcGOjSH8eyF475HA",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "How much are you willing to spend on headphones? Today we compare $8 headphones from Polaroid to $80 headphones from Beats. Which are the best headphones for the money?",
  },

  {
    _id: "En8bS5RM-oI",
    category: "Unboxing",
    views: "1.5M",
    duration: "6:37",
    alt: "Are Bone Conduction Headphones Right For You?",
    title: "Are Bone Conduction Headphones Right For You?",
    thumbnail:
      "https://i.ytimg.com/vi/En8bS5RM-oI/hq720.jpg?sqp=-oaymwEcCOgCEMoBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBKFlKxZKefkyI34WJPTgy-_ziU-w",
    creatorName: "Unbox Therapy",
    avatar:
      "https://yt3.ggpht.com/ytc/AKedOLQf2e6s9_FvCfjFM14z_q7LUwlu5J7sUaBak7VtPw=s48-c-k-c0x00ffffff-no-rj",

    description:
      "The AfterShokz Aeropex are the latest flagship bone conduction headphones from AfterShokz. Bone conduction technology delivers audio through your cheekbones.",
  },
];
